import { lazy } from "react";

const RadioData = [
  /*** Multimedia */
  {
    path: "/admin/multimedia/songs",
    acl: "view-songs",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/songs/SongsTable")
    ),
  },

  {
    path: "/admin/multimedia/jingles",
    acl: "view-jingles",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/jingles/JingleTable")
    ),
  },
  {
    path: "/admin/multimedia/generics",
    acl: "view-credits",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/credits/CreditTable")
    ),
  },
  {
    path: "/admin/multimedia/publicities",
    acl: "view-ads",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/ads/AdsTable")
    ),
  },
  {
    path: "/admin/multimedia/playlists",
    acl: "view-playlists",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/playlist/PlaylistsTable")
    ),
  },
  {
    path: "/admin/multimedia/playlist/comments",
    acl: "view-playlist-comments",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/playlist/CommentTable")
    ),
  },
  {
    exact: true,
    path: "/admin/multimedia/playlist/:id/comment",
    acl: "view-comments-playlist-id",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/playlist/Comments")
    ),
  },

  {
    path: "/admin/multimedia/albums",
    acl: "view-albums",
    component: lazy(() => import("@src/views/BackOffice/multimedia/albums")),
  },
  {
    path: "/admin/multimedia/artistes",
    acl: "view-artistes",
    component: lazy(() => import("@src/views/BackOffice/multimedia/artistes")),
  },
  {
    path: "/admin/categories/media",
    acl: "view-categories-media",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/category/CategoriesList")
    ),
  },
  {
    path: "/admin/tags/media",
    acl: "view-tags-media",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/tags/TagTable")
    ),
  },

  /** Planning  */
  {
    path: "/admin/planning/emissions",
    acl: "view-emissions",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/emissionsTable")
    ),
  },
  {
    path: "/admin/planning/emission/comments",
    acl: "view-emissions-comment",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/CommentTable")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/emission/:id/comment",
    acl: "view-comments-emission-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/Comments")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/category",
    acl: "view-planning-category",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/category/CategoriesTable")
    ),
  },
  {
    exact: true,
    path: "/admin/background_image",
    acl: "view-background-image",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/background_image/BackgroundTable")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/classification",
    acl: "view-planning-classification",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/planning/classification/ClassificationTable"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/planning/language",
    acl: "view-planning-language",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/language/LanguageTable")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/tag",
    acl: "view-planning-tag",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/tag/TagTable")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episodes",
    acl: "view-episodes",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/planning/episodes/tab_episode/EpisodeFolders"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episodes/:id",
    acl: "view-episode-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/episodes/profile")
    ),
  },
  {
    path: "/admin/default_playlist",
    acl: "view-default-playlist",
    component: lazy(() =>
      import("@src/views/BackOffice/radio/defaultPls/DefaultPlsTable")
    ),
  },
  {
    path: "/admin/calendar",
    acl: "view-calendar",
    component: lazy(() => import("@src/views/BackOffice/planning/calendar")),
  },

  {
    path: "/admin/podcasts",
    acl: "view-podcasts",
    component: lazy(() => import("@src/views/BackOffice/planning/podcast")),
  },
  {
    path: "/admin/podcast/comments",
    acl: "view-podcasts-comments",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/podcast/CommentTable")
    ),
  },
  {
    exact: true,
    path: "/admin/podcast/:id/comment",
    acl: "view-comments-podcast-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/podcast/Comments")
    ),
  },
  {
    exact: true,
    path: "/admin/rushs",
    acl: "view-rushs",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/rush/rushs/tab_rush/RushFolders")
    ),
  },
  {
    exact: true,
    path: "/admin/rush/waiting_room",
    acl: "view-rush-waiting-room",
    component: lazy(() => import("@src/views/BackOffice/planning/RoomRush")),
  },
  {
    exact: true,
    path: "/admin/rush/:id",
    acl: "view-rush-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/rush/profile")
    ),
  },
  {
    path: "/admin/live/waiting_room",
    acl: "view-live-waiting-room",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/liveWaitingRoom")
    ),
  },
  {
    path: "/admin/studio/live",
    acl: "view-studio-live",
    component: lazy(() => import("@src/views/BackOffice/studio")),
    layout: "StudioLayout",
    meta: {
      isStudio: true,
    },
  },
  {
    path: "/admin/studio/rush",
    acl: "view-studio-rush",
    component: lazy(() => import("@src/views/BackOffice/studio_rush")),
  },
  {
    path: "/admin/rushByCategory/:id",
    acl: "view-rush-category-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/rush/rushsByCategory")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episodesByEmission/:id",
    acl: "view-episodes-emission-id",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/planning/episodes/EpisodeByEmission/EpisodesByEmission"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episode/category/:name/:id",
    acl: "view-episodes-category-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/episodes/EpisodeByCategory")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episode/tag/:name/:id",
    acl: "view-episodes-tag-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/episodes/EpisodeByTag")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/episode/classification/:name/:id",
    // acl: "view-episode-classification-id",
    acl: "view-episodes-tag-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/episodes/EpisodeByClassification")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/emission/category/:name/:id",
    acl: "view-emissions-category-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/emissionByCategory")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/emission/tag/:name/:id",
    acl: "view-emissions-tag-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/emissionByTag")
    ),
  },
  {
    exact: true,
    path: "/admin/planning/emission/classification/:id",
    acl: "view-emission-classification-id",
    component: lazy(() =>
      import("@src/views/BackOffice/planning/emissions/emissionClassification")
    ),
  },
  {
    exact: true,
    path: "/admin/multimedia/playlist/category/:id",
    acl: "view-playlists-category-id",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/playlist/PlaylistByCategory")
    ),
  },
  {
    exact: true,
    path: "/admin/multimedia/media/type/:type_id/category/:category_id",
    acl: "view-media-category-id",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/mediaByCategory")
    ),
  },
];

export default RadioData;
